module.exports = __webpack_public_path__ + "static/map-b8b2f526691ee738719d193d8e0d3843.svg";